// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"d5a42557","113":"99ba8447","160":"d99477cf","211":"d9ab7052","630":"9e29371e","670":"bce14121","902":"0cbd890a","909":"e12f4221","935":"1f105cf2"}[chunkId] + ".chunk.js";
};